import { createAction, props } from '@ngrx/store';

import { BetslipTeaserActions } from './actions';
import { BetslipTeaserPickPointsTrackingData, BetslipTeaserTrackingData } from './models';

export class TeaserBetTrackingActions {
    static readonly ACTION_SCHEMA = `${BetslipTeaserActions.ACTION_SCHEMA}/tracking`;

    private static readonly TRACK_TEASER_PICK_REMOVE = `${TeaserBetTrackingActions.ACTION_SCHEMA}/TRACK_TEASER_PICK_REMOVE`;

    private static readonly TRACK_TEASER_PICKS_LOAD = `${TeaserBetTrackingActions.ACTION_SCHEMA}/TRACK_TEASER_PICKS_LOAD`;

    private static readonly TRACK_TEASER_POINTS_SELECTION = `${TeaserBetTrackingActions.ACTION_SCHEMA}/TRACK_TEASER_POINTS_SELECTION`;

    private static readonly TRACK_TEASER_POINTS_INFO_SELECTION = `${TeaserBetTrackingActions.ACTION_SCHEMA}/TRACK_TEASER_POINTS_INFO_SELECTION`;

    private static readonly TRACK_TEASER_ERRORS = `${TeaserBetTrackingActions.ACTION_SCHEMA}/TRACK_TEASER_ERRORS`;

    private static readonly TRACK_TEASER_PICK_TOGGLE = `${TeaserBetTrackingActions.ACTION_SCHEMA}/TRACK_TEASER_PICK_TOGGLE`;

    private static readonly TRACK_TEASER_PICK_POINTS = `${TeaserBetTrackingActions.ACTION_SCHEMA}/TRACK_TEASER_PICK_POINTS`;

    /**
     * tracking teaser Remove Pick
     */
    static trackTeaserPickRemove = createAction(TeaserBetTrackingActions.TRACK_TEASER_PICK_REMOVE, props<{ payload: BetslipTeaserTrackingData }>());

    /**
     * tracking teaser points selection
     */
    static trackTeaserPointsSelection = createAction(
        TeaserBetTrackingActions.TRACK_TEASER_POINTS_SELECTION,
        props<{ payload: BetslipTeaserTrackingData }>(),
    );

    /**
     * tracking teaser points info selection
     */
    static trackTeaserPointsInfoSelection = createAction(
        TeaserBetTrackingActions.TRACK_TEASER_POINTS_INFO_SELECTION,
        props<{ payload: BetslipTeaserTrackingData }>(),
    );

    /**
     * tracking teasers load
     */
    static trackTeaserPicksLoad = createAction(TeaserBetTrackingActions.TRACK_TEASER_PICKS_LOAD, props<{ payload: BetslipTeaserTrackingData }>());

    /**
     * tracking teaser Errors
     */
    static trackTeaserError = createAction(TeaserBetTrackingActions.TRACK_TEASER_ERRORS, props<{ payload: BetslipTeaserTrackingData }>());

    /**
     * tracking teaser pick toggle
     */
    static trackTeaserPickToggle = createAction(TeaserBetTrackingActions.TRACK_TEASER_PICK_TOGGLE, props<{ payload: BetslipTeaserTrackingData }>());

    /**
     * tracking teaser Pick points
     */
    static trackTeaserPickPoints = createAction(
        TeaserBetTrackingActions.TRACK_TEASER_PICK_POINTS,
        props<{ payload: BetslipTeaserPickPointsTrackingData[] }>(),
    );
}
